import './index.scss';
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useDropzone } from "react-dropzone";
import axios from 'axios';
import Utils from '../../CourseApp/Helper/utils';

import {
    IconPlusSmallWhite
} from '../../icons/svgs';
import manager from '../../Manager';

function ThumbnailsControl({ structure, saveValue, defaultValue, selectedSlide, runtimeValue, showModalCrop }) {

    const [controlValue, setControlValue] = useState(defaultValue ?? {});
    const videoUploadStatus = selectedSlide.data.video?.directPlayUrl;
    const inputFileRef = useRef(null);
    const controlType = selectedSlide.data.platform;
    let guid = selectedSlide.data.video?.guid;

    const controlRules = structure?.rules;
    const controlRulesAllowedFileType = controlRules.allowedFileType ? controlRules.allowedFileType : ['.jpg'];
    const controlRulesMaxFileSize = controlRules.maxFileSize;
    const fileManagerUrl = manager.settings.filemanagerUrl;
    const tempUploadUrl = fileManagerUrl + '/temp';
    const baseUrl = manager.settings.baseUrl;
    const setVideoThumbnailUrl = baseUrl + '/setVideoThumbnail';

    const onDrop = useCallback(async (acceptedFiles) => {
        const file = acceptedFiles[0];
        const validExtensions = controlRulesAllowedFileType;
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        if (!validExtensions.includes(fileExtension)) {
            Utils.showError('allowed file type .' + validExtensions);
            return;
        }
        if (file.size > controlRulesMaxFileSize) {
            Utils.showError('Maximum file size: ' + Utils.convertBytes(controlRulesMaxFileSize));
            return;
        }
        let url = await showModalCrop(file, 16 / 9);
        saveValue({});
        selectedSlide.saveDisabled = true;
        uploadFile(Utils.base64ToImageFile(url, file.name), guid);
    }, [guid]);

    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': []
        },
        multiple: false,
        maxFiles: 1,
        onDrop
    });

    const uploadFile = (file, videoID) => {
        const formData = new FormData();
        formData.append('file', file);
        axios.post(tempUploadUrl, formData)
            .then((response) => {
                let responseData = response.data;
                let errCode = responseData.errCode;
                let errMessage = responseData.errMessage;
                let data = responseData.data;
                if (errCode > 0) {
                    Utils.showError(errMessage);
                }
                if (errCode === 0) {
                    let fileUploaded = data.file[0];
                    setVideoThumbnail(videoID, fileUploaded);
                    Utils.showLoading('Processing video thumbnail, once successful it will not immediately change your video preview', true, 'setThumbnail');
                }
            })
            .catch((error) => {
                Utils.showError('An error occurred while uploading the file:' + error);
            });
    };

    // reference https://docs.bunny.net/reference/video_setthumbnail
    const setVideoThumbnail = (videoID, fileUploaded) => {
        let fullUrl = fileUploaded.fullUrl;
        if (fullUrl && videoID) {
            axios.post(setVideoThumbnailUrl, {
                videoId: videoID,
                thumbnailUrl: fullUrl
            }).then((response) => {
                let responseData = response.data;
                let errCode = responseData.errCode;
                let errMessage = responseData.errMessage;
                if (errCode > 0) {
                    Utils.showError(errMessage);
                }
                if (errCode === 0) {
                    setControlValue(fileUploaded);
                    saveValue(fileUploaded);
                    selectedSlide.saveDisabled = false;
                    Utils.dismissAllToast();
                }
            }).catch((error) => {
                Utils.showError('An error occurred while uploading the file:' + error);
            });
        }
    }

    const onImageClick = () => {
        inputFileRef.current.click();
    }

    useEffect(() => {
        if (typeof defaultValue !== 'undefined') {
            setControlValue(defaultValue);
        } else {
            setControlValue({});
        }
    }, [defaultValue]);

    return (
        (videoUploadStatus && controlType === "files") ?
            <>
                <div className="tbcourse-editor-control-item-label">
                    {structure.labelOnChangeOption}
                </div>
                <div className="tbcourse-editor-control-image">
                    <div {...getRootProps({ className: 'dropzone-wrapper' })} style={{ display: Object.keys(controlValue).length === 0 ? 'block' : 'none' }}>
                        <input {...getInputProps()} ref={inputFileRef} />
                        <div className='upload-area'>
                            <IconPlusSmallWhite />
                        </div>
                    </div>
                    <div className='upload-preview' onClick={onImageClick} style={{ display: Object.keys(controlValue).length !== 0 ? 'block' : 'none', cursor: 'pointer' }}>
                        <div className='image-thumbnail' key={controlValue?.fileId}>
                            <div className='image-thumbnail-wrapper' style={{ backgroundImage: 'url(' + controlValue?.fullUrl + ')' }}>
                                <img
                                    alt='preview'
                                    src={controlValue?.fullUrl}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </> : ''
    );
}

export default ThumbnailsControl;
